import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  ChakraProvider,
  theme,
} from '@chakra-ui/react';
import { ColorModeSwitcher } from './ColorModeSwitcher';
import './Styles/App.css'
import Navbar from './Components/Navbar';
import Home from './Pages/Home';
import About from './Pages/About';
import Skill from './Pages/Skill';
import Projects from './Pages/Projects';
import Contact from './Pages/Contact';
import Loader from './Components/Loader';
function App() {
  const [loader,setLoader] = useState(true)
  const homeRef=useRef()
  const infoRef=useRef()
  const skillRef=useRef()
  const projectsRef=useRef()
  const contactRef=useRef();
  const updateStatus=()=>{
   setLoader(false)
  }
  useEffect(()=>{
    setInterval(()=>{
      updateStatus()
    },1200)
  })
  
     if(loader){
      return <Loader />
    }      
    else{
      return <Box className='App_main_bg'>
      {/* Navbar */}
      
      <Box className="Navbar">
          <Navbar homeRef={homeRef} infoRef={infoRef} skillRef={skillRef} projectsRef={projectsRef} contactRef={contactRef} />
          <ChakraProvider theme={theme}>
         <Box className="theme_change">
           <ColorModeSwitcher className="ColorMod" />
          </Box>
        </ChakraProvider>
      </Box > 
      {/* containers */}
      {/* <Box  className="content_items"> */}
     <Box border="1px solid red" h="60px" visibility={"hidden"}></Box>
     <Box mt="200px"></Box>
      <Box ref={homeRef} className='item_container' ><Home /></Box>
      <Box ref={infoRef} className='item_container'><About /></Box>
      <Box ref={skillRef} className='item_container'><Skill /></Box>
      <Box ref={projectsRef} className='item_container'><Projects /></Box>
      <Box ref={contactRef} className='item_container'><Contact /></Box>
     </Box>
    }
  
}

export default App;
 